module.exports = __webpack_public_path__ + "img/clean-code.de2545cd.png";